import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { Card } from '@/components/ui/card';
import { useOwnUpcomingAppointmentsQuery } from '@/hooks/useOwnUpcomingAppointmentsQuery';
import { useVisitCalendarAndPricing } from './useVisitCalendarAndPricing';
import { VisitRow } from './VisitRow';

export function UpcomingVisitsCard() {
  const { t } = useTranslation('clients');
  const query = useOwnUpcomingAppointmentsQuery(true);
  const visits = query.data === undefined ? [] : query.data;
  const { formatVisitPrice, downloadVisitCalendar } = useVisitCalendarAndPricing();

  return (
    <Card as="section">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name="Calendar" />
        </span>
        <h2 className="text-sm font-bold text-zooindigo">{t('portal.upcomingVisits')}</h2>
      </div>
      {query.isLoading === true ? (
        <div className="py-4 flex justify-center">
          <LoadingSpinner className="w-6 h-6" />
        </div>
      ) : visits.length === 0 ? (
        <p className="text-[13px] text-zoomuted py-1">{t('portal.noUpcomingVisits')}</p>
      ) : (
        <div className="space-y-2">
          {visits.map(function renderVisit(visit) {
            return (
              <VisitRow
                key={visit.id}
                visit={visit}
                priceLabel={formatVisitPrice(visit.therapyType)}
                onAddToCalendar={downloadVisitCalendar}
              />
            );
          })}
        </div>
      )}
    </Card>
  );
}
